import React from "react";
import { Link } from "react-router-dom";
import { Stethoscope, Phone, Mail, MapPin, Clock, Instagram, Facebook, Youtube } from "lucide-react";
import { clinic } from "../data/mock";

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="container-app py-14 grid gap-10 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-11 h-11 rounded-xl bg-sky-500 grid place-items-center text-white">
              <Stethoscope size={22} />
            </div>
            <div>
              <div className="font-heading font-bold text-white text-lg">{clinic.doctorName}</div>
              <div className="text-[11px] text-sky-400 font-semibold uppercase tracking-wide">{clinic.tagline}</div>
            </div>
          </div>
          <p className="text-sm leading-relaxed text-slate-400">
            Expert diagnosis and personalized treatment for fatty liver, cirrhosis, hepatitis, jaundice and all liver &amp; digestive disorders in Varanasi.
          </p>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-white mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-sky-400 transition-colors">Home</Link></li>
            <li><Link to="/gastro-liver-specialist-dr-indresh-dixit" className="hover:text-sky-400 transition-colors">About Dr. Dixit</Link></li>
            <li><Link to="/best-liver-doctor-in-varanasi" className="hover:text-sky-400 transition-colors">Best Liver Doctor in Varanasi</Link></li>
            <li><Link to="/fatty-liver-treatment-varanasi" className="hover:text-sky-400 transition-colors">Fatty Liver Treatment</Link></li>
            <li><Link to="/liver-cirrhosis-treatment-varanasi" className="hover:text-sky-400 transition-colors">Liver Cirrhosis Treatment</Link></li>
            <li><Link to="/hepatitis-treatment-varanasi" className="hover:text-sky-400 transition-colors">Hepatitis Treatment</Link></li>
            <li><Link to="/jaundice-treatment-varanasi" className="hover:text-sky-400 transition-colors">Jaundice &amp; Liver Infection</Link></li>
            <li><Link to="/liver-tests-varanasi" className="hover:text-sky-400 transition-colors">Liver Tests</Link></li>
            <li><Link to="/liver-disease-symptoms" className="hover:text-sky-400 transition-colors">Liver Disease Symptoms</Link></li>
            <li><Link to="/contact" className="hover:text-sky-400 transition-colors">Contact &amp; Appointment</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-white mb-4">Clinic Locations</h4>
          <ul className="space-y-4 text-sm">
            {clinic.branches.map((b) => (
              <li key={b.name}>
                <div className="flex items-start gap-2">
                  <MapPin size={16} className="text-sky-400 mt-0.5 shrink-0" />
                  <div>
                    <span className="text-white font-medium">{b.name}</span>
                    <p className="text-slate-400">{b.address}</p>
                    <p className="flex items-center gap-1 text-slate-400 mt-1"><Clock size={13} /> {b.timings}</p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-white mb-4">Get in Touch</h4>
          <ul className="space-y-3 text-sm">
            <li><a href={`tel:${clinic.phone.replace(/\s/g, "")}`} className="flex items-center gap-2 hover:text-sky-400 transition-colors"><Phone size={16} className="text-sky-400" /> {clinic.phone}</a></li>
            <li><a href={`mailto:${clinic.email}`} className="flex items-center gap-2 hover:text-sky-400 transition-colors"><Mail size={16} className="text-sky-400" /> {clinic.email}</a></li>
          </ul>
          <div className="flex items-center gap-3 mt-5">
            <a href={clinic.social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-9 h-9 rounded-lg bg-slate-800 hover:bg-sky-500 grid place-items-center transition-colors"><Instagram size={18} /></a>
            <a href={clinic.social.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-9 h-9 rounded-lg bg-slate-800 hover:bg-sky-500 grid place-items-center transition-colors"><Facebook size={18} /></a>
            <a href={clinic.social.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="w-9 h-9 rounded-lg bg-slate-800 hover:bg-sky-500 grid place-items-center transition-colors"><Youtube size={18} /></a>
          </div>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="container-app py-5 text-center text-xs text-slate-500">
          &copy; {new Date().getFullYear()} {clinic.clinicName}. All rights reserved. | {clinic.doctorName} — {clinic.tagline}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
